import React from 'react';
import { Box, Typography } from "@mui/material";

export default function AccountSummary() {
  return (
    <Box>
      <Typography variant="body1">
        Nesta etapa você vai criar uma conta de desenvolvedor Apple para sua empresa.
        Esta conta é necessária para que o seu aplicativo iOS possa ser publicado.
      </Typography>
    </Box>
  )
}